import React from 'react';
import * as _ from 'lodash';
import {
  Button,
  ControlLabel, FormControl, FormGroup,
} from 'react-bootstrap';
import {SubscribeStore} from '../../stores/SubscribeStore';
import {JsonEditor} from 'react-json-edit';
import {toast} from 'react-toastify';

export default class RealtimeDebug extends React.Component {

  static defaultProps = {
    sending: false,
    channel_id: 'realtime_debug',
    data: {
      /**
       * Example for info
       */
      'example-confirm-api': {
        title: 'Example Buttons Notification',
        content: 'ดูผลลัพธ์ได้ที่ https://putsreq.com/VnxVg9kePlts5MSGdDIZ/inspect',
        message_type: 'confirm',
        message_options: {
          type: 'api',
          onConfirm: {
            type: 'api',
            url: 'https://putsreq.com/VnxVg9kePlts5MSGdDIZ',
            data: {
              confirm: true,
            },
          },
          onCancel: {
            type: 'api',
            url: 'https://putsreq.com/VnxVg9kePlts5MSGdDIZ',
            data: {
              confirm: false,
            },
          },
        },
        options: {
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: false,
        },
      },
      /**
       * Example for buttons
       */
      'example-buttons': {
        title: 'Example Confirm Notification',
        content: 'ดูผลลัพธ์ได้ที่ https://putsreq.com/VnxVg9kePlts5MSGdDIZ/inspect',
        message_type: 'buttons',
        message_buttons: [
          {
            text: 'Yes',
            style: 'primary',
            action: {
              type: 'api',
              url: 'https://putsreq.com/VnxVg9kePlts5MSGdDIZ',
              data: {
                confirm: true,
              },
            },
          },
          {
            text: 'No',
            style: 'default',
            action: {
              type: 'api',
              url: 'https://putsreq.com/VnxVg9kePlts5MSGdDIZ',
              data: {
                confirm: false,
              },
            },
          }],
        options: {
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: false,
        },
      },

      /**
       * Example for api
       */
      'example-info': {
        title: 'โลเร็ม อิน ไทย',
        content: 'แจ่มใสมูลฐานวจีกรรมเจ้าของเหมาะสม ทศชาติพลเมืองมัดหมี่เนื้อตัว ปลดระวางปรัยัติธรรมธรรมชาติภาพลักษณ์แผนภูมิ',
        message_type: 'info',
        options: {
          position: toast.POSITION.BOTTOM_RIGHT,
        },
      },

      /**
       * Example for api
       */
      'example-info-custom-duration': {
        title: 'Example with duration',
        content: 'แสดง notification ระยะเวลา 10 วินาที',
        message_type: 'info',
        options: {
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: true,
          autoClose: 10000,
        },
      },

      /**
       * Example for api
       */
      'example-prompt': {
        title: 'Example Prompt',
        content: 'ป้อนข้อความและดูผลลัพธ์ได้ที่ https://putsreq.com/VnxVg9kePlts5MSGdDIZ/inspect',
        placeholder: 'ป้อนข้อความอะไรก็ได้',
        message_type: 'prompt',
        message_options: {
          type: 'api',
          url: 'https://putsreq.com/VnxVg9kePlts5MSGdDIZ',
        },
        options: {
          position: toast.POSITION.BOTTOM_RIGHT,
          closeOnClick: false,
          autoClose: 10000,
        },
      },
    },
  };

  realtime = null;
  onSendClick = () => {

    const params = {
      sending: true,
      channel_id: this.channel_id.value || this.props.channel_id,
    };

    this.setState(params, () => {
      const send_data = _.pick(this.state, ['channel_id', 'data']);
      this.realtime = new SubscribeStore();
      this.realtime.connect(send_data.channel_id, () => {

        this.realtime.send(send_data);
        console.log('send data', send_data);
        this.realtime.disconnect();

        this.setState({sending: false,sendJsonText:JSON.stringify(send_data)});
      });
    });

  };

  dataChange = (json) => {
    this.setState({data: json});
  };

  onExampleChange = (e) => {
    this.setState({
      data: this.props.data[this.example.value],
    });
  };

  constructor(props) {
    super(props);
    this.state = {
      sending: props.sending,
      channel_id: props.channel_id,
      data: props.data['example-confirm-api'],
      sendJsonText:''
    }

  }

  render() {
    let {sendJsonText} = this.state
    return (
        <div className="content">
          <form>
            <FormGroup>
              <ControlLabel>Channel ID</ControlLabel>
              <FormControl
                  inputRef={(ref) => this.channel_id = ref}
                  type="text"
                  placeholder={this.props.channel_id} />
            </FormGroup>

            <FormGroup>
              <ControlLabel>Select Example Data</ControlLabel>
              <FormControl
                  onChange={this.onExampleChange}
                  inputRef={(ref) => this.example = ref}
                  componentClass="select">
                {_.map(this.props.data, (item, key) =>
                    <option key={key} value={key}>{key}</option>,
                )}
                {/*<option value="example-info">Info</option>*/}
              </FormControl>
            </FormGroup>

            <FormGroup>
              <ControlLabel>Data</ControlLabel>
              <JsonEditor
                  tableLike={true}
                  value={this.state.data}
                  propagateChanges={this.dataChange} />
            </FormGroup>

            <FormGroup>
              <Button className={{disabled: this.state.sending}}
                      bsStyle="success"
                      onClick={this.onSendClick}>
                {this.state.sending ? 'Sending' : 'Send'}
              </Button>
            </FormGroup>
          </form>
          <FormControl  componentClass="textarea" value={sendJsonText}/>
        </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/view/debug/RealtimeDebug.js